import { Component, ElementRef, EventEmitter, Inject, Input, OnInit, Output, PLATFORM_ID, TemplateRef, ViewChild } from "@angular/core";
import { NgbModal } from "@ng-bootstrap/ng-bootstrap";
import { CustomerService } from "src/app/shareModule/services/customer.service";
import { LocalServiceService } from "src/app/shareModule/services/local-service.service";
import { environment } from "src/environments/environment";
import { isPlatformBrowser } from "@angular/common";
import { AuthServiceService } from "src/app/shareModule/services/auth-service.service";
import { RecommandationsFormComponent } from "../../recommandations-form/recommandations-form.component";
import { CompareProductListComponent } from "src/app/customers/compare-product-list/compare-product-list.component";

@Component({
  selector: "app-header-search-map",
  templateUrl: "./header-search-map.component.html",
  styleUrls: ["./header-search-map.component.scss"],
})
export class HeaderSearchMapComponent implements OnInit {
  @ViewChild("keywordContainer") keywordContainer!: ElementRef;

  // Inputs
  @Input() design: string = "";
  arrow: boolean = false;
  item: any = {
    0: {
      items: 2,
    },
  };
  // Output Events
  @Output() onChangeEvent = new EventEmitter<any>();
  @Output() view = new EventEmitter<any>();
  public screenWidth: number;
  public imgUrl = environment.ImageUrl;
  public isLogin: any = 0;
  public maps: any = {
    search: "",
    postalCode: "All",
    radius: 5,
    products: [],
    productsToCompare: [],
    all: true,
    subCategoriesBasedOnKeyWords: []
  };
  public popularKeywords: any = [];
  public memberShopPageSize: number;
  /**
   * Constructor
   */
  constructor(
    private modalService: NgbModal,
    private local: LocalServiceService,
    private customerService: CustomerService,
    private auth: AuthServiceService,
    @Inject("WINDOW") private window: any,
    @Inject(PLATFORM_ID) private platformId: Object
  ) {
    this.isLogin = this.local.getUser()?.id ? 1 : 0;
    if (isPlatformBrowser(this.platformId)) {
      this.screenWidth = this.window.innerWidth;
    }
    this.memberShopPageSize = this.screenWidth < 768 ? 4 : 8;
  }

  ngOnInit(): void {
    this.maps.radius = "All";
    // this.maps.postalCode = this.local.getPostalCode();
    this.local.getUserDetailsObserver().subscribe((user) => {
      if (user?.id) {
        const { postalCode } = user;
        if (postalCode) {
          this.maps.postalCode = postalCode;
        }
      }
    });
  }

  openFilterModal(modal: any) {
    this.modalService.dismissAll();
    this.modalService.open(modal, {
      size: "lg",
      // focusFirst: false
    });
    // Disable Auto-Focus Using Modal Options
    setTimeout(() => {
      const modalElement = document.querySelector(".modal");
      const firstInput = modalElement?.querySelector("input, button, select, textarea, a[href]");
      if (firstInput) {
        (firstInput as HTMLElement).blur();
      }
    }, 0);
  }


  private _getPopularKeywords() {
    this.customerService.popularMemberShopKeyword().subscribe((response) => {
      this.popularKeywords = response.body;
    });
  }

  public handleKeywordsValue(value: string) {
    this.maps.search = value;

  }

  private _clickSearch(){
    document.getElementById("btnSearchGmap").click();
  }
  public handleSearch(value: any) {
    this.maps.radius = value;
    this._clickSearch();
  }

  public viewProduct(product: any) {
    this.view.emit(structuredClone(product));
    this.handleSearch(this.maps.radius)
  }
  /***************************************************** code related to comparing products ***************************/





  public openRecommendationForm(){
    this.modalService.open(RecommandationsFormComponent)
  }

  


  public async openCompareProductsModal(){
    //used to open a modal that is used to comapre the top 5 results from the search
  
    this.maps.productsToCompare.forEach(
      pd =>{
        this.productBottomDiscussExperienceTabSettings.push(this.getBottomTabInfo(pd));
      }
    )
     
    this.loadCompareProductsRatings();
    await this.loadOtherImagesOfCompareProducts();
    this.maps.productsToCompare.forEach(prod => prod.enableMemberShop = true)

    setTimeout(()=>{
      const ref = this.modalService.open(CompareProductListComponent, {size: 'lg', windowClass: 'transparent-window', modalDialogClass: 'glass-bg', centered: true});
      ref.componentInstance.productsToCompare = this.maps.productsToCompare;
      ref.componentInstance.productBottomDiscussExperienceTabSettings = this.productBottomDiscussExperienceTabSettings
    }, 0)
   
  }
  public getBottomTabInfo(pd){
    if(!pd){
      return []
    }
    return [
      {
        title: 'Experiences',
        condition: pd?.xpCount > 0
      },
      {
        title: 'Discuss',
        condition: pd?.forum 
      },
    ]

  }
  productBottomDiscussExperienceTabSettings = [
    
  ]
  public productSelectedChanged(product, isSelected){
    let indexOfProduct = this.maps.productsToCompare.indexOf(product)
    if(isSelected){
      if(indexOfProduct == -1){
        this.maps.productsToCompare.push(product);
      }
    }
    else{
      if(indexOfProduct !== -1){
        this.maps.productsToCompare.splice(indexOfProduct, 1)
      }
    }
  }


  private loadRatingOn(pd){
    let ratings = []

    if (pd && pd['seller_info']) {

      
      let sellerInfo = pd['seller_info'];
      //console.log('seller_info is in productData', sellerInfo) //DELETE LATTER
      //console.log('seller info is ', sellerInfo)

      if(sellerInfo && typeof sellerInfo === 'string'){
        sellerInfo = JSON.parse(sellerInfo)
      }else{
        pd.ratings = []
      }
      if ('googleReviewRating' in sellerInfo && (sellerInfo.googleReviewRating  || sellerInfo.googleReviewCount || sellerInfo.googleReviewUrl)) {
        ratings.push({
          icon: 'ggle.png',
          name: 'Google Reviews',
          ratingUrl: sellerInfo.googleReviewUrl,
          rating: sellerInfo.googleReviewRating,
          counts: sellerInfo.googleReviewCount
        })
      }
      if ('fbReviewRating' in sellerInfo && (sellerInfo.fbReviewRating  || sellerInfo.fbReviewCount || sellerInfo.fbReviewUrl)) {
        ratings.push({
          icon: 'facebook.png',
          name: 'Facebook Reviews',
          ratingUrl: sellerInfo.fbReviewUrl,
          rating: sellerInfo.fbReviewRating,
          counts: sellerInfo.fbReviewCount
        })
      }

      if ('carousellReviewRating' in sellerInfo  && (sellerInfo.carousellReviewRating  || sellerInfo.carousellReviewCount || sellerInfo.carousellReviewUrl)) {
        ratings.push({
          icon: 'carousell.png',
          name: 'Carousel Reviews',
          ratingUrl: sellerInfo.carousellReviewUrl,
          rating: sellerInfo.carousellReviewRating,
          counts: sellerInfo.carousellReviewCount
        })
      }




    }
    ratings = structuredClone(ratings)
    //console.log('ratings are ',  ratings)
    pd.ratings = ratings
  }

    private loadCompareProductsRatings() {
      //console.log('LOADING ratings') //DELETE LATTER
      for(const pd of this.maps.productsToCompare){
        this.loadRatingOn(pd)
      }
    }

    private getImageByAccessor(images, accessor){
      const imageObj = images?.find((o) => o.imageAccessor === accessor);
      return imageObj ? imageObj.image : "";
    };

    private loadOtherImagesOfProduct(productData){
      productData["foodSpecs"] = productData?.memberShopProductsVariations || [];
      productData["food_image_1"] = this.getImageByAccessor(productData.memberShopProductsImages, "image1");
      productData["food_image_active"] = productData["food_image_1"];
      productData["food_image_2"] = this.getImageByAccessor(productData.memberShopProductsImages, "image2");
      productData["food_image_3"] = this.getImageByAccessor(productData.memberShopProductsImages, "image3");
      productData["food_image_4"] = this.getImageByAccessor(productData.memberShopProductsImages, "image4");

     
    }
    private loadOtherImagesOfCompareProducts(){
      return new Promise( 
        (res, rej) =>{
          for(const prod of this.maps.productsToCompare){
            this.loadOtherImagesOfProduct(prod)
          }
          res(1)

        }
      );
  
      
      
    }


  /***************************************************** code related to types ***************************************/
  public selectedTypesId = new Set();
  private _fetchProductsUsingSelectedTypes(){
    let selectedTypeIds = Array.from(this.selectedTypesId);
    if(selectedTypeIds.length == 0){
      this._clickSearch();
      return;
      //selectedTypeIds = Array.from(this.maps.subCategoriesBasedOnKeyWords.map(c => c.subcategoryTypes).flat().map(type => type.id))
    }
   
    this.auth.fetchProductsBasedOnTypes(selectedTypeIds)
    .subscribe({
      next: (data: any)=>{
        this.maps.products = data.data;
      },
      error: err =>{
        console.error(err);
      }
    })
  }



  public toggleTypeAndSearch(type){
    if(this.selectedTypesId.has(type.id)){
      this.selectedTypesId.delete(type.id)
    }else{
      this.selectedTypesId.add(type.id)
    }
     
    this._fetchProductsUsingSelectedTypes();
  }
}
